import React from 'react';
import { Sparkles, ExternalLink, MapPin } from 'lucide-react';
import './NewVendorsBanner.css';

// ============================================
// VENDOR DATA - bHyyve New Vendors
// ============================================
const newVendors = [
  {
    id: 1,
    name: "Autocraft Professionals",
    joinDate: "Dec 12, 2025",
    logo: "https://i.ibb.co/p8HJ19d/1000234974.jpg",
    website: "https://www.autocraftprofessionals.com/",
    category: "Auto Detailing",
    badgeColor: "#EF4444",
    location: "Oakville, Brampton",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 2,
    name: "Velvet Touch Cleaning Co.",
    joinDate: "Dec 1, 2025",
    logo: "https://i.ibb.co/hxPnFd2z/Logo.png",
    website: "https://www.bhyyve.com",
    category: "Cleaning",
    badgeColor: "#3B82F6",
    location: "Brampton",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 3,
    name: "One More Bite",
    joinDate: "Dec 24, 2025",
    logo: "https://i.ibb.co/hx37Pn0v/LOGO.jpg",
    website: "https://www.bhyyve.com",
    category: "Food and Drinks",
    badgeColor: "#EC4899",
    location: "Brampton",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 4,
    name: "CoinCraft",
    joinDate: "Jan 4, 2026",
    logo: "🪙",
    website: "https://www.coincraft.ca",
    category: "Financial Services",
    badgeColor: "#F59E0B",
    location: "Toronto",
    mapLink: ""
  },
  {
    id: 5,
    name: "Nectar Financing Co.",
    joinDate: "Jan 4, 2026",
    logo: "https://i.ibb.co/3yVZXTqN/Create-a-logo-for-Nectar-a-micoloan-financing-company.jpg",
    website: "https://www.bhyyve.com",
    category: "Financial Services",
    badgeColor: "#D4AF37",
    location: "Toronto",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 6,
    name: "Susy's Professional Cleaning Services",
    joinDate: "Jul 24, 2025",
    logo: "🧹",
    website: "https://www.bhyyve.com",
    category: "Cleaning",
    badgeColor: "#EF4444",
    location: "London",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 7,
    name: "Sparkle Sisters",
    joinDate: "Jul 25, 2025",
    logo: "https://i.ibb.co/9HjJcsWQ/Sparkle.png",
    website: "https://www.bhyyve.com",
    category: "Cleaning",
    badgeColor: "#3B82F6",
    location: "Brampton",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 8,
    name: "True Fresh Systems",
    joinDate: "Sep 20, 2025",
    logo: "https://i.ibb.co/gLX7R5QD/Geometric-Water-Droplet-Logo-for-True-Fresh-Systems.png",
    website: "https://www.bhyyve.com",
    category: "Cleaning",
    badgeColor: "#10B981",
    location: "Oakville",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 9,
    name: "Maison de L'Auto",
    joinDate: "Nov 22, 2025",
    logo: "https://i.ibb.co/ns4MJtyY/Maison-de-l-auto.png",
    website: "https://www.bhyyve.com",
    category: "Auto Services",
    badgeColor: "#1a1a1a",
    location: "Mississauga, Brampton",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 10,
    name: "Blossom and Blade",
    joinDate: "Sep 24, 2025",
    logo: "https://i.ibb.co/d4FKzZ8Q/Logo.jpg",
    website: "https://www.bhyyve.com",
    category: "Landscaping",
    badgeColor: "#22C55E",
    location: "London, Brampton, Mississauga, Oakville",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 11,
    name: "Anshin Moving Company",
    joinDate: "Sep 24, 2025",
    logo: "https://i.ibb.co/HDmFbhmb/Logo.jpg",
    website: "https://www.bhyyve.com",
    category: "Moving Services",
    badgeColor: "#1e3a8a",
    location: "Brampton, Mississauga, Oakville",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 12,
    name: "SnowMow Pros",
    joinDate: "Sep 24, 2025",
    logo: "https://i.ibb.co/9344YQ6p/Logo.jpg",
    website: "https://www.bhyyve.com",
    category: "Landscaping",
    badgeColor: "#f5f5f5",
    location: "Brampton, Mississauga, Oakville",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 13,
    name: "Suggaholic",
    joinDate: "Jan 26, 2026",
    logo: "https://i.ibb.co/bgyJf76f/Trans-New.avif",
    website: "https://suggaholic.ca/",
    category: "Food and Beverage",
    badgeColor: "#8B4513",
    location: "Brampton",
    mapLink: "https://suggaholic.ca/"
  },
  {
    id: 14,
    name: "Rivani Home Cleaning",
    joinDate: "Feb 8, 2026",
    logo: "https://customer-assets.emergentagent.com/job_service-hive-2/artifacts/5wfyq53k_LOGO.png",
    website: "https://www.bhyyve.com",
    category: "Cleaning",
    badgeColor: "#A3A347",
    location: "Dundas",
    mapLink: "https://www.bhyyve.com"
  },
  {
    id: 15,
    name: "Streamify TV",
    joinDate: "Feb 8, 2026",
    logo: "https://customer-assets.emergentagent.com/job_service-hive-2/artifacts/6ia8rg7j_Create%20a%20logo%20for%20Streamify%20TV.jpg",
    website: "https://www.bhyyve.com",
    category: "Entertainment",
    badgeColor: "#E11D48",
    location: "Hamilton",
    mapLink: "https://www.bhyyve.com"
  },
  
  // ADD MORE VENDORS BELOW:
  
];

const VendorCard = ({ vendor }) => {
  // Determine if badge text should be dark based on background color brightness
  const isLightBadge = ['#f5f5f5', '#ffffff', '#FFFFFF', '#F5F5F5', '#D4AF37', '#F59E0B', '#fbbf24'].includes(vendor.badgeColor);
  
  // Check if vendor joined in January 2026 for celebration effect
  const isJanuary2026 = vendor.joinDate.includes('Jan') && vendor.joinDate.includes('2026');
  
  return (
    <a
      href={vendor.website}
      target="_blank"
      rel="noopener noreferrer"
      className={`vendor-card group ${isJanuary2026 ? 'celebration-card' : ''}`}
      data-testid={`vendor-card-${vendor.id}`}
    >
      {/* Sparklers for January 2026 vendors */}
      {isJanuary2026 && (
        <>
          <div className="sparkle sparkle-1">✨</div>
          <div className="sparkle sparkle-2">✨</div>
          <div className="sparkle sparkle-3">⭐</div>
          <div className="sparkle sparkle-4">✨</div>
          <div className="sparkle sparkle-5">🎉</div>
          <div className="celebration-glow"></div>
        </>
      )}
      
      {/* Badge */}
      <div 
        className="vendor-badge"
        style={{ backgroundColor: vendor.badgeColor }}
      >
        <span className="vendor-badge-text" style={{ color: isLightBadge ? '#000000' : '#ffffff' }}>NEW</span>
      </div>
      
      {/* Logo */}
      <div className="vendor-logo">
        {vendor.logo.startsWith('http') ? (
          <img 
            src={vendor.logo} 
            alt={`${vendor.name} logo`}
            className="w-full h-full object-cover rounded-lg"
          />
        ) : (
          <span className="text-2xl">{vendor.logo}</span>
        )}
      </div>
      
      {/* Info */}
      <div className="vendor-info">
        <h4 className="vendor-name">{vendor.name}</h4>
        <p className="vendor-category">{vendor.category}</p>
        {vendor.location && (
          <a 
            href={vendor.mapLink} 
            target="_blank" 
            rel="noopener noreferrer"
            className="vendor-location"
            onClick={(e) => e.stopPropagation()}
          >
            <MapPin size={12} />
            <span>{vendor.location}</span>
          </a>
        )}
        <p className="vendor-date">Joined {vendor.joinDate}</p>
      </div>
      
      {/* External Link Icon */}
      <div className="vendor-link-icon">
        <ExternalLink size={14} />
      </div>
    </a>
  );
};

const NewVendorsBanner = () => {
  // Duplicate vendors for seamless infinite scroll
  const duplicatedVendors = [...newVendors, ...newVendors];

  return (
    <div className="new-vendors-banner" data-testid="new-vendors-banner">
      {/* Banner Header */}
      <div className="banner-header">
        <div className="banner-header-content">
          <Sparkles className="text-yellow-400 animate-pulse" size={18} />
          <span className="banner-title">Welcome Our Newest Busy Bees!</span>
          <Sparkles className="text-yellow-400 animate-pulse" size={18} />
        </div>
      </div>
      
      {/* Scrolling Container */}
      <div className="vendors-scroll-container">
        <div className="vendors-scroll-track">
          {duplicatedVendors.map((vendor, index) => (
            <VendorCard key={`${vendor.id}-${index}`} vendor={vendor} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewVendorsBanner;
